@if (content().teaserTitle) {
  <h1 class="article-title nordic-blue-900-text text-icon-primary mr-small-b ms-clear-t font-headline-medium">
    {{ content().teaserTitle }}
  </h1>
}
<div
  class="article-lead nordic-blue-900-text text-icon-primary bold-type ms-large-b"
  [innerHTML]="content().teaserText | finSafe: 'html'"
></div>

@for (contentImage of content().media; track contentImage.contentId) {
  <figure class="hero-image ms-clear-x ms-clear-t ms-small-b">
    <fin-content-image class="block image-height radius-medium" [imageData$]="contentImage | finToObservable" />
    @if (contentImage.teaserText) {
      <figcaption
        [innerHTML]="contentImage.teaserText | finSafe: 'html'"
        class="hero-image-caption light-type nordic-blue-900-text text-icon-primary ms-xxsmall-t ms-large-b font-body-small"
      ></figcaption>
    }
  </figure>
}
<div class="flex">
  <div class="">
    @for (author of content().authors; track $index) {
      <fin-author class="block" [author]="author.htmlTitle" />
    }

    @if (hasUpdatedTag()) {
      <fin-date class="block" [text]="'shared.published' | finLocalization" [date]="publicationDate()" />
      <fin-date class="block" [text]="'shared.updated' | finLocalization" [date]="content().externallyDisplayedDate" />
    } @else {
      @if (content().localSettings?.firstPublished) {
        <fin-date class="block" [text]="'shared.published' | finLocalization" [date]="publicationDate()" />
      }
      <fin-date
        class="block"
        [text]="content().localSettings?.firstPublished ? ('shared.updated' | finLocalization) : null"
        [date]="content().externallyDisplayedDate"
      />
    }
  </div>
  <div class="flex flex-1 flex--end">
    <fin-social [url]="content().url" [title]="content().teaserTitle" />
  </div>
</div>
<div class="ms-large-t article-markup ms-large-b" [innerHTML]="content().detailText | finSafe: 'html'"></div>
@for (detailTextItem of content().detailTextItems; track $index) {
  <fin-detail-text [mediaObject]="detailTextItem.media" [markup]="detailTextItem.markup" />
}
